import { render, staticRenderFns } from "./LoginPhoneCall.vue?vue&type=template&id=33c6929b&scoped=true&"
import script from "./LoginPhoneCall.vue?vue&type=script&lang=js&"
export * from "./LoginPhoneCall.vue?vue&type=script&lang=js&"
import style0 from "./LoginPhoneCall.vue?vue&type=style&index=0&id=33c6929b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c6929b",
  null
  
)

export default component.exports